import { ToolCall } from './tool-call';

export default {
  tag: 'toolcall',
  format: `<ToolCall />`,
  sourcePipeline: (source: string) => source,
  componentFn: ({ node, ...props }: any) => {
    return <ToolCall {...props} />;
  },
};
